/*******************************************************************************************/
/*  작 성 자 : 바이크뱅크(주)
/*  작 성 일 : 2023.10.11
/*  수 정 일 : 2023.
/*  버     전 : 0.0.1
/*  설     명 : storage 관련
/*  위     치 : src/utils/UtilsStorage.js
/*******************************************************************************************/
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

/*
 * @constant COOKIE_KEY cookie key값
 */
export const STORAGE_KEY = {
    IS_BANNER_ONE: 'is_banner_one',
    IS_BANNER_TWO: 'is_banner_two',
    IS_BANNER_THREE: 'is_banner_three',
}

/*
 * localStorage get
 */
export const getLocalStorage = key => {
    return localStorage.getItem(key)
}

/*
 * localStorage set
 */
export const setLocalStorage = (key, value) => {
    localStorage.setItem(key, value)
}

/*
 * localStorage remove
 */
export function removeLocalStorage(key) {
    localStorage.removeItem(key)
}

/*
 * localStorage all remove
 */
export function clearocalStorage() {
    localStorage.clear()
}

/*
 * @constant get Cookie
 */
export const getCookie = key => {
    return cookies.get(key)
}

/*
 * @constant  set Cookie
 */
export const setCookie = (key, value, option) => {
    return cookies.set(key, value, option)
}

/*
 * @constant remove Cookie
 */
export function removeCookie(name) {
    cookies.remove(name)
}
